import React from 'react';
import NumInput from './NumInput';
import styled from 'styled-components';

const StyledForm = styled.form`
  font-family: "Roboto", Arial, sans-serif;
  font-size: 18px;
  font-weight: 300;
`; 

const Form = ({
    handleInputChange,
    inputValues
}) => (
  <div className="tsc-calc__form card">
    <StyledForm>
      <NumInput
        name="numberVehicles"
        labelText="Fleet Size:"
        handleInputChange={handleInputChange}
        value={inputValues.numberVehicles}
      />
      <NumInput
        name="timeOperational"
        labelText="Yearly Operational Days: "
        handleInputChange={handleInputChange}
        value={inputValues.timeOperational}
      />
      {/* <NumInput
        name="timeDown"
        labelText="Downtime in days per vehicle in a year"
        handleInputChange={handleInputChange}
        value={inputValues.timeDown}
      /> */}
      <NumInput
        name="timeLast"
        labelText="Number of Pages in Inspection Booklet: "
        handleInputChange={handleInputChange}
        value={inputValues.timeLast}
      />
      <NumInput
        name="costPerBooklet"
        labelText="Inspection Booklet Cost: "
        handleInputChange={handleInputChange}
        value={inputValues.costPerBooklet}
      />
      {/* <NumInput
        name="timeBetween"
        labelText="Days between inspections handed-in and when it was completed"
        handleInputChange={handleInputChange}
        value={inputValues.timeBetween}
      /> */}
      <NumInput
        name="timeProcess"
        labelText="Minutes to Process and Analyze each Inspection/Workorder: "
        handleInputChange={handleInputChange}
        value={inputValues.timeProcess}
      />
      <NumInput
        name="hourlyWage"
        labelText="Manager Hourly Wage: "
        handleInputChange={handleInputChange}
        value={inputValues.hourlyWage}
      />
      
      
    </StyledForm>
  </div>
);

export default Form;